import { ProjectDto } from '../api/model';
import { postProject } from '../api/project-api/project-api';
import { useApiMutation, getApiErrorMessage } from './useApiMutation';

interface CreateProjectOptions {
  onSuccess?: (project: ProjectDto) => void;
  onError?: (error: Error) => void;
}

export const useCreateProject = (options?: CreateProjectOptions) => {
  return useApiMutation(
    (projectData: ProjectDto) => {
      return postProject(projectData);
    },
    {
      ...options,
      invalidateQueries: ['projects', '/project'],
    }
  );
};

export const getErrorMessage = getApiErrorMessage;
